
import mediator from '../js/mediator';
import config from '../js/config';

let livePersonService;

export class LivePersonService {

  static getInstance() {
    if (!livePersonService) {
      livePersonService = new LivePersonService();
    }
    return livePersonService;
  }

  constructor() {
    this.isOnline = false;
    this.checkingOnlineStatus = false;
    this.onlineStatusChecked = false;
    this.statusImageSrc = '';
    this.initStatusImage();
  }

  checkStatus() {
    if (!this.onlineStatusChecked && !this.checkingOnlineStatus) {
      if (this.statusImageSrc) {
        this.checkingOnlineStatus = true;
        this.statusImage.src = this.statusImageSrc;
      } else {
        this.setOffline();
      }
    }
    return this;
  }

  /**
   * @private
   */
  initStatusImage() {
    this.statusImage = new Image();
    this.statusImage.addEventListener('load', this.onChatImageLoaded.bind(this));
  }

  /**
   * @private
   */
  onChatImageLoaded() {
    if (this.statusImage.width) {
      this.setOnline();
    } else {
      this.setOffline();
    }
  }

  /**
   * @private
   */
  setOnline() {
    this.isOnline = true;
    this.checkingOnlineStatus = false;
    this.onlineStatusChecked = true;
    mediator.trigger(config.events.chat.online);
  }

  /**
   * @private
   */
  setOffline() {
    this.isOnline = false;
    this.checkingOnlineStatus = false;
    this.onlineStatusChecked = true;
    mediator.trigger(config.events.chat.offline);
  }

}



// WEBPACK FOOTER //
// ./assets/services/LivePersonService.js